export default function StatusMessage({ type = "info", children, id }) {
  if (!children) return null;

  const assertive = type === "danger" || type === "warning";

  return (
    <div
      id={id}
      className={`alert alert-${type} py-2`}
      role={assertive ? "alert" : "status"}
      aria-live={assertive ? "assertive" : "polite"}
    >
      {children}
    </div>
  );
}
